import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Button, Popover } from "antd";
import "./index.css";

function ActionButtons(props) {
  const [isPopover, setIsPopover] = useState(false);
  const svgSource = useSelector((state) => state.svgViewerData);
  const parts = useSelector((state) => state.svgViewerPartData);
  const UploadOptions = useSelector((state) => state?.UploadFieldsOptions);

  const defaultScaleOptions = [
    { id: 1, scaleName: "Inch" },
    { id: 2, scaleName: "Millimeter" },
    { id: 3, scaleName: "Centimeter" },
  ];

  const getScaleIdFromUnit = (unit) => {
    const normalizedUnit = String(unit || "").toLowerCase();

    if (
      normalizedUnit === "1" ||
      normalizedUnit === "in" ||
      normalizedUnit === "inch" ||
      normalizedUnit === "inches"
    ) {
      return 1;
    }

    if (
      normalizedUnit === "2" ||
      normalizedUnit === "mm" ||
      normalizedUnit === "millimeter" ||
      normalizedUnit === "millimeters"
    ) {
      return 2;
    }

    if (
      normalizedUnit === "3" ||
      normalizedUnit === "cm" ||
      normalizedUnit === "centimeter" ||
      normalizedUnit === "centimeters"
    ) {
      return 3;
    }

    return null;
  };

  const handleScale = (e) => {
    props.setSelectedScale(Number(e.target.value));
  };

  const renderStatus = () => {
    const status = parts.data?.configData?.metaData?.configStatus;

    return (
      <div className="form-group search-box" style={{ marginRight: "8px" }}>
        <span style={{ minWidth: "70px", textTransform: "capitalize" }}>
          {status !== undefined ? status : "--"}
        </span>
      </div>
    );
  };

  const handlePopoverChange = (event) => {
    setIsPopover(event);
  };

  const handleDownload = (type) => {
    const configId = parts.data.configData.metaData.configId;
    const assemblyId = svgSource.data.assemblyData.metaData.assemblyID;
    let url = "";

    if (type === "assembly") {
      url = `assembly?assemblyID=${assemblyId}`;
    } else if (type === "configuration") {
      url = `config?configId=${configId}`;
    }

    const win = window.open(
      `${process.env.REACT_APP_BACKEND_API_URL}/api/download/${url}`,
      "_blank"
    );

    if (win) {
      win.focus();
    }
  };

  const downloadPopover = () => {
    const configStatus =
      parts?.data?.configData?.metaData?.configId !== undefined &&
      parts.data.configData.metaData.configId !== "";

    return (
      <span style={{ display: "flex" }}>
        <Button
          onClick={() => handleDownload("assembly")}
          size="default"
          style={{ padding: "10px", margin: "5px", height: "auto" }}
        >
          <p style={{ marginBottom: "0px" }}>Assembly</p>
        </Button>

        <Button
          disabled={!configStatus}
          onClick={() => handleDownload("configuration")}
          size="default"
          style={{ padding: "10px", margin: "5px", height: "auto" }}
        >
          <p style={{ marginBottom: "0px" }}>Configuration</p>
        </Button>
      </span>
    );
  };

  const handleSave = () => {
    props.handleSaveEvent(true);
  };

  const renderPreviewBtnTxt = () => {
    if (props.preview === false) {
      return props.moduleName === "config-viewer"
        ? "View Assembly"
        : "Preview Config";
    }

    return props.moduleName === "config-viewer"
      ? "View Config"
      : "View Assembly";
  };

  const renderActionButtons = () => {
    const status = parts.data?.configData?.partData.length;
    const partModified = parts.data?.configData?.modified;
    const len =
      parts.data?.configData?.partData === undefined
        ? 0
        : parts.data?.configData?.partData.length;

    return (
      <>
        <button
          type="button"
          className="btn btn-outline-info btn23"
          disabled={status === 0 || props.editMode}
          data-target="#exampleModal2"
          onClick={props.previewActive}
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <i className="now-ui-icons media-2_sound-wave"></i>&nbsp;
          {renderPreviewBtnTxt()}
        </button>

        <button
          type="button"
          className="btn btn-primary btn23 btn39"
          disabled={
            partModified === undefined ||
            partModified === false ||
            len === 0 ||
            props.editMode
          }
          data-target="#exampleModal2"
          onClick={handleSave}
        >
          <i className="now-ui-icons arrows-1_cloud-download-93"></i>&nbsp;Save
        </button>
      </>
    );
  };

  useEffect(() => {
    if (props.moduleName === "config-viewer") {
      const configScaleId = getScaleIdFromUnit(
        parts?.data?.configData?.metaData?.configUnits
      );

      if (configScaleId !== null) {
        props.setSelectedScale(configScaleId);
      }
    }
  }, [
    props.moduleName,
    parts?.data?.configData?.metaData?.configUnits,
    props.setSelectedScale,
  ]);

  return (
    <div
      className="header-btn-grp"
      style={{ textAlign: "center", paddingLeft: "20px" }}
    >
      {!props.preview && props.moduleName === "config-viewer" ? (
        <div>
          <div className="header-title-txt">
            <span> Configuration Scale</span>
          </div>

          <div className="dropdown">
            <select
              disabled={props.editMode}
              id="cadScale"
              key="cadScale"
              value={props.selectedScale}
              onChange={handleScale}
              className="scale-drop-down"
            >
              {(UploadOptions?.data?.scaleOptions || defaultScaleOptions).map(
                (value) => (
                  <option key={value?.id} value={value?.id}>
                    {value?.scaleName}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
      ) : (
        ""
      )}

      <div style={{ marginTop: "8px" }}>{renderStatus()}</div>

      <Popover
        placement="bottom"
        content={downloadPopover}
        trigger="click"
        visible={isPopover}
        onVisibleChange={handlePopoverChange}
        arrowPointAtCenter
      >
        <button
          type="button"
          className="btn btn-outline-info btn23"
          data-toggle="modal"
          data-target="#exampleModal2"
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <i className="now-ui-icons arrows-1_cloud-download-93"></i>
          &nbsp;Download
        </button>
      </Popover>

      {renderActionButtons()}
    </div>
  );
}

ActionButtons.propTypes = {
  preview: PropTypes.bool,
  moduleName: PropTypes.string,
  handleSaveEvent: PropTypes.func,
  previewActive: PropTypes.func,
  selectedScale: PropTypes.number,
  setSelectedScale: PropTypes.func.isRequired,
  editMode: PropTypes.bool,
};

export default ActionButtons;